{
	"title": "Pagina non trovata (404)",
	"description": "Questa pagina non è stata trovata perché non disponi dei diritti di accesso necessari per aprirla oppure perché non esiste. Se hai copiato e incollato l’URL, assicurati che sia stato copiato correttamente.",
	"secondaryButtonTitle": "Apri {{page}}"
}
